(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/login-checks/login-check.js') >= 0) return;  svs.modules.push('/modules/player-login/views/login-checks/login-check.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.login_check = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<main id=\"containerRegion\">\n"
    + ((stack1 = container.invokePartial((lookupProperty(helpers,"template")||(depth0 && lookupProperty(depth0,"template"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"template","hash":{},"data":data,"loc":{"start":{"line":2,"column":6},"end":{"line":2,"column":16}}}),depth0,{"hash":{"action":(depth0 != null ? lookupProperty(depth0,"action") : depth0),"model":(depth0 != null ? lookupProperty(depth0,"model") : depth0)},"data":data,"indent":"  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</main>\n";
},"usePartial":true,"useData":true});
Handlebars.partials['svs-player_login-login_check'] = svs.player_login.templates.login_check;
})(svs, Handlebars);


 })(window);